import type { ListingLocaleOverrides } from '../base';

export const FLOverrides: ListingLocaleOverrides = {
  locale: 'FL',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText: 'Copy legal description from tax records',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
          },
        },
      },
    },
    sellerSideContacts: {
      cards: {
        sellerCard: {
          fields: {
            powerOfAttorneyFirstName: {
              label: 'Authorized Signer First Name',
            },
            powerOfAttorneyLastName: {
              label: 'Authorized Signer Last Name',
            },
          },
        },
      },
    },
    buyerSideContacts: {
      cards: {
        buyerCard: {
          fields: {
            powerOfAttorneyFirstName: {
              label: 'Authorized Signer First Name',
            },
            powerOfAttorneyLastName: {
              label: 'Authorized Signer Last Name',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        titleOfficerContactCard: {
          hideByDefault: false,
          displayFields: (displayFields) =>
            displayFields.filter(
              (field) => field.name !== 'contacts.titleOfficer.x.titleNumber',
            ),
          layout: (layout) =>
            layout.filter(
              (fields) =>
                !fields.find(
                  ({ name }) => name === 'contacts.titleOfficer.x.titleNumber',
                ),
            ),
          fields: {
            titleNumber: null,
          },
        },
      },
    },
  },
};
